import { read as readXlsx, utils as xlsxUtils } from "xlsx";

export const readClipboardHtmlTable = (clipboard: DataTransfer): string[][] => {
  const workbook = readXlsx(clipboard.getData("text/html"), { type: "string", FS: "," });
  const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  return xlsxUtils.sheet_to_json<string[]>(worksheet, { header: 1 });
};

export const readSpreadsheetFile = async (file: File): Promise<{ table: string[][]; name: string }> => {
  const workbook = readXlsx(await file.arrayBuffer());
  const name = workbook.SheetNames[0];
  const table = xlsxUtils.sheet_to_json<string[]>(workbook.Sheets[name], { header: 1 });
  return { table, name };
};

export const trimEmptyRows = (table: string[][]): string[][] =>
  table.filter((row) => row.some((value) => !!`${value ?? ""}`.trim()));
